import {
  Users,
  CheckCircle,
  Clock,
  TrendingUp,
  DollarSign,
} from "lucide-react";
import { StatCard } from "@/components/shared/StatCard";
import { useSubscriptionStats } from "@/hooks/useSubscriptions";
import { formatCurrency } from "@/utils/format";

export const SubscriptionStats = () => {
  const { data, isLoading } = useSubscriptionStats();

  const total = data?.total ?? 0;
  const active = data?.active ?? 0;
  const trialing = data?.trialing ?? 0;
  const totalRevenue = data?.totalRevenue ?? 0;
  const monthRevenue = data?.monthRevenue ?? 0;

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
        {Array.from({ length: 5 }).map((_, i) => (
          <div
            key={i}
            className="bg-card rounded-card border border-border p-5 animate-pulse h-24"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
      <StatCard
        title="Total"
        value={total}
        subtitle="All subscriptions"
        icon={Users}
        variant="default"
      />
      <StatCard
        title="Active"
        value={active}
        subtitle="Paying providers"
        icon={CheckCircle}
        variant="success"
      />
      <StatCard
        title="Trialing"
        value={trialing}
        subtitle="On free trial"
        icon={Clock}
        variant="info"
      />
      <StatCard
        title="This Month"
        value={formatCurrency(monthRevenue)}
        subtitle="Revenue collected"
        icon={TrendingUp}
        variant="success"
      />
      <StatCard
        title="Total Revenue"
        value={formatCurrency(totalRevenue)}
        subtitle="All time"
        icon={DollarSign}
        variant="default"
      />
    </div>
  );
};
